import AvatarIcon from 'assets/icon/AvatarIcon'
import MenuIcon from 'assets/icon/MenuIcon'
import LogoutButton from 'components/Button/LogoutButton'
import Dropdown from 'components/Input/Dropdown'
import { useEffect, useState, useContext } from 'react'
import { LocationContext } from './MainContainer'

function Navbar({ toggleSidebar }) {
	let pathArray = window.location.pathname.split("/")

	const [userLocationAccessOptions, setUserLocationAccessOptions] = useState(JSON.parse(localStorage.getItem("UserLocation")) || [])
	const [selectedLocation, setSelectedLocation] = useState(localStorage.getItem("LocationId"))
	const { locationId, setLocationId } = useContext(LocationContext);

	const selectedLocationChange = (option) => {
		setSelectedLocation(option.value)
		setLocationId(option.value)

		localStorage.setItem("LocationId", option.value)
		localStorage.setItem("LocationName", option.label)
	}

	function fLogoutBtnClick(){
		localStorage.removeItem("Token")
		localStorage.removeItem("Username")
		localStorage.removeItem("FirstName")
		localStorage.removeItem("LastName")
		localStorage.removeItem("Email")

		window.location.href = "/login"
	}

	useEffect(() => {
		if (userLocationAccessOptions.length === 1) {
			setSelectedLocation(userLocationAccessOptions[0].value)
			localStorage.setItem("LocationId", userLocationAccessOptions[0].value)
			setLocationId(userLocationAccessOptions[0].value)
		} else if (userLocationAccessOptions.length > 1) {
			if ((localStorage.getItem("LocationId") === null || localStorage.getItem("LocationId") === "") && userLocationAccessOptions.length > 0) {
				setSelectedLocation(userLocationAccessOptions[0].value)
				localStorage.setItem("LocationId", userLocationAccessOptions[0].value)
				setLocationId(userLocationAccessOptions[0].value)
			}
		} else {
			localStorage.setItem("LocationId", "")
		}
	}, [])

   	return (
		<div className={`sticky top-0 bg-white transition-all z-20 w-full flex justify-between items-center py-2 px-4`}>
			<div className='flex items-center gap-4'>
				<button className='block' onClick={toggleSidebar}>
					<MenuIcon className='fill-black w-5' />
				</button>
				<span className='text-lg font-semibold hidden md:block'>Yupiter Finance {pathArray[1] === "location" ? " - " + localStorage.getItem("LocationName") : ""}</span>
			</div>
			<div className='flex gap-3 justify-between items-center'>
				<div className='bg-black px-4 py-1 rounded-full items-center hidden md:flex'>
					<h1 className='pl-12 sm:pl-0 text-white'>Welcome back, { localStorage.getItem("FullName") }</h1>
				</div>

				<div className='flex gap-2 items-center'>
					<span className='hidden sm:block'>Location : </span>

					{userLocationAccessOptions.length <= 1 &&
						<span>{userLocationAccessOptions.length === 1 ? userLocationAccessOptions[0].label : "N/A"}</span>
					}
					{userLocationAccessOptions.length > 1 && (
						<Dropdown className='w-64 ' options={userLocationAccessOptions} value={selectedLocation} onChange={selectedLocationChange} />
					)}
				</div>
				{/* <button onClick={ () => { window.location.href = "/" }}>
					<span>Home</span>
				</button> */}
				
				<div className="relative flex items-center justify-center">
					<LogoutButton onClick={() => { fLogoutBtnClick() }} />
				</div>
			</div>
		</div>
	)
}

export default Navbar